import React from "react";
import "./Dashboard.css";
import {Container, Row, Col} from "react-bootstrap";
import LiveChat from 'react-livechat';
import {mygaSession} from "../../scripts/myga-session";
import AppPageHeader from "../Application/AppPageHeader/AppPageHeader";
import {PAGES} from "../../scripts/constants";

class TreasuryRateList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {rates: []};
  }

  componentDidMount() {
    let rates = [];
    let formatDateString = date => new Date(date).toLocaleDateString("en-US", {year: 'numeric', month: 'short', day: 'numeric'});
    if (this.props.type === 'bill') {
      rates = mygaSession.getTreasuryRates().billRates.map(item => {
        return {
          low: parseFloat(item.lowDiscountRate).toFixed(2),
          avg: parseFloat(item.averageMedianDiscountRate).toFixed(2),
          high: parseFloat(item.highDiscountRate).toFixed(2),
          issueDate: formatDateString(item.issueDate),
          maturityDate: formatDateString(item.maturityDate),
          term: item.term
        }
      });
    } else if (this.props.type === 'note') {
      rates = mygaSession.getTreasuryRates().noteRates.map(item => {
        return {
          low: parseFloat(item.lowYield).toFixed(2),
          avg: parseFloat(item.averageMedianYield).toFixed(2),
          high: parseFloat(item.highYield).toFixed(2),
          issueDate: formatDateString(item.issueDate),
          maturityDate: formatDateString(item.maturityDate),
          term: item.term
        }
      })
    }

    this.setState({rates})
  };

  headerStyles = {
    fontSize: '.7em',
    backgroundColor: 'var(--HeaderBackgroundYellow)'
  };

  renderRow = data => {
    return (
      <Row>
        <Col className={'col-3'}>
          <Container className={'p-0'}>
            <Row>
              {data.term}
            </Row>
            <Row style={{fontSize: '.7em'}}>
              {data.issueDate}
            </Row>
          </Container>
        </Col>
        <Col className={'col-3'}>
          <Container className={'p-0'}>
            <Row>&nbsp;</Row>
            <Row style={{fontSize: '.7em'}}>
              {data.maturityDate}
            </Row>
          </Container>
        </Col>
        <Col className={'col-2'}>{data.low}%</Col>
        <Col className={'col-2'}>{data.avg}%</Col>
        <Col className={'col-2'}>{data.high}%</Col>
      </Row>
    )
  };

  title = (this.props.type === 'bill') ? 'Treasury Bill Rates' : 'Treasury Note Rates';
  render() {

    return (


      <Container className="page-area noselect">
        <div className={'page-content-area'}>
        <AppPageHeader fullPage headerLabel={this.title} updatePage={this.props.updatePage}/>
        <Row style={this.headerStyles}>
          <Col className={'col-3'}>Issue Date</Col>
          <Col className={'col-3'}>Maturity Date</Col>
          <Col className={'col-2'}>Low</Col>
          <Col className={'col-2'}>Avg</Col>
          <Col className={'col-2'}>High</Col>
        </Row>
        <Container className={'p-0'} style={{overflowY: 'auto'}}>
          {this.state.rates.map(item => (this.renderRow(item)))}
          <div style={{marginBottom: '2em'}}/>
        </Container>
          </div>
        <LiveChat license={11222357} group={2}/>
      </Container>


    );

  }
}

export default TreasuryRateList;